import React from 'react'
import {
  NumericFormat as ReactNumericFormat,
  NumericFormatProps as ReactNumericFormatProps,
} from 'react-number-format'

type TPickedProp =
  | 'allowLeadingZeros'
  | 'allowNegative'
  | 'aria-label'
  | 'autoFocus'
  | 'className'
  | 'decimalScale'
  | 'disabled'
  | 'displayType'
  | 'fixedDecimalScale'
  | 'getInputRef'
  | 'id'
  | 'name'
  | 'onBlur'
  | 'onValueChange'
  | 'placeholder'
  | 'prefix'
  | 'renderText'
  | 'suffix'
  | 'thousandSeparator'
  | 'type'
  | 'value'
  | 'valueIsNumericString'

export interface INumericFormatProps extends Pick<ReactNumericFormatProps, TPickedProp> {
  'data-test'?: string
}

const NumericFormat = (props: INumericFormatProps) => {
  return <ReactNumericFormat {...props} />
}

export default NumericFormat
